<!-- 新-被引推送 - 推送任务 -->
<template>
  <div class="cited-push-template-config">
    <div class="page-content">
      <!-- 页面内容待开发 -->
      <templateConfig
        :description="'在集群层面，对被引推送的邮件模板进行配置管理。'"
        @toDetail="toDetail"
        :template-options="citationTypes"
      ></templateConfig>
    </div>
  </div>
</template>

<script>
import templateConfig from '@/components/templateConfig/templateConfig.vue'
import templateConfigMixin from '@/mixins/templateConfig'
export default {
  name: 'CitedPushTemplateConfig',
  components: {
    templateConfig
  },
  mixins: [templateConfigMixin],
  data() {
    return {}
  },
  mounted() {},
  methods: {
    toDetail(row) {
      const columnId = this.$route.query.columnId || '11-4' // 新-被引推送 -> 模板配置
      this.$router.push({
        path: '/citedPushTemplateConfigDetail',
        query: {
          templateId: row.id,
          type: row.type,
          columnId
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.cited-push-template-config {
  .page-header {
    padding: 20px;
    h2 {
      margin: 0;
      font-size: 18px;
      font-weight: 500;
    }
  }
  .page-content {
    padding: 20px;
  }
}
</style>
